import { render } from "./WCLabel.vue?vue&type=template&id=769e49fa"
import script from "./WCLabel.vue?vue&type=script&lang=js"
export * from "./WCLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__